const User_Types = {};

Object.defineProperties(User_Types, {
  PAY_G: {
    value: 'payG',
    writable: false,
    configurable: false,
    enumerable: true,
  },
  PAY_M: {
    value: 'payM',
    writable: false,
    configurable: false,
    enumerable: true,
  },
  // DEPRECATEME: since [Release 22]
  SOHO: {
    configurable: false,
    get: () => {
      console.warn('User_Types.SOHO is now deprecated use App_Types.SOHO instead');
      return 'soho';
    },
    enumerable: true,
  },
  CHOOSER: {
    value: 'chooser',
    writable: false,
    configurable: false,
    enumerable: true,
  },
  USER: {
    value: 'user',
    writable: false,
    configurable: false,
    enumerable: true,
  },
  MVA12: {
    value: 'mva12',
    writable: false,
    configurable: false,
    enumerable: true,
  },
});

export { User_Types }; // eslint-disable-line import/prefer-default-export
